<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">جنسیت</h4>
    </div>
    <div class="card-body d-flex justify-content-around">
      <div class="form-check" v-for="(gender, index) in genders" :key="index">
        <input
            class="form-check-input"
            type="radio"
            :id="index"
            :value="gender"
            v-model="jobQualification.gender"
        />
        <label class="form-check-label" :for="index">{{ gender }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      genders: {
        genderMale: 'مرد',
        genderFemale: 'زن',
        genderNoPreference: 'فرقی ندارد',
      }
    }
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      },
    }
  }
};
</script>
